<form #saveItemForm="ngForm" [ngClass]="{'disabled-content': loadingSpinner}">
  <div class="add-item-block">
    <div class="area-block">
			<textarea #punchItemTextArea class="text-area" matInput placeholder="Punch Item Description" [required]="true"
                minlength="3" type="text" [(ngModel)]="itemDescription" name="itemDescription" tabindex="1"
                [mention]="users"
                [mentionConfig]="{triggerChar:'@', maxItems:25, labelKey:'username', mentionSelect: onMentionSelect}" appPasteFileDirective
                (filePaste)="uploadFile($event)" [disabled]="!canEditText"></textarea>

      <mat-icon class="cancel-item-button" (click)="hideInputItem()">close</mat-icon>
    </div>

    <div class="files-block">
      <app-task-checkitem-files [checkItem]="checkItem" [progressBar]="progressBar" [projectId]="projectId">
      </app-task-checkitem-files>
    </div>

    <div class="types-block">
      <app-task-checkitem-tags [checkItem]="checkItem" (tagChangedEmitter)="tagChanged($event)" [tags]="tags">
      </app-task-checkitem-tags>
    </div>

    <div class="buttons-block">
      <button mat-button class="add-item-button" (click)="saveItem()" [disabled]="!canSave()">
        <span *ngIf="!loadingSpinner">Save</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>

      <p-fileUpload mode="basic" name="files" #filesForm [customUpload]="true"
                    (uploadHandler)="uploadFile($event.files, filesForm)" [auto]="true" [multiple]="true"
                    chooseLabel="">
      </p-fileUpload>

      <div class="space-block"></div>

      <button mat-button class="delete-item-button" (click)="deleteItem()">
        <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
        <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
      </button>

    </div>
  </div>
</form>
